import { MenuItem, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

export interface Option {
  text: string
  value: string
}

interface DeleteReasonDropdownProps {
  deletedItemString: string
  onChange: (value: string) => void
  options: Option[]
  value: string | undefined
  reasonIsRequired?: boolean
}

export function DeleteReasonDropdown({ deletedItemString, onChange, options, value, reasonIsRequired }: DeleteReasonDropdownProps) {
  const { t } = useTranslation()

  return (
    <TextField
      fullWidth
      helperText={t('DeleteFlow.Reason.Text', { item: deletedItemString })}
      id='DeleteReason'
      label={t('DeleteFlow.Reason.Label')}
      margin='dense'
      name='DeleteReason'
      onChange={event => {
        onChange(event.target.value)
      }}
      required={reasonIsRequired}
      select
      value={value ?? ''}
      variant='outlined'
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.text}
        </MenuItem>
      ))}
    </TextField>
  )
}
